import './item.css'
import React from "react"
import NETImage from 'components/net-image'
import { useHistory } from "react-router-dom"
import { THEME_PATH } from "routes/path"

/**
 * 首页课程主题项
 */
export default function ThemeItem({ item }) {
    const history = useHistory()

    return (
        <NETImage
            useAutoHeight
            src={item.cover}
            className='home-item'
            onClick={() => history.push(THEME_PATH(item.name))}
        />
    )
}